import React from 'react';
import {CssBaseline, Paper, Typography, withStyles} from "@material-ui/core";
import {styles} from './styles'

class PathError extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            timeout: 10
        };
    }

    onTimeout() {
        this.setState(prevState => ({ timeout: prevState.timeout - 1 }));
        if (this.state.timeout === 0){
            window.location.pathname = '/login'
        }
        setTimeout(()=> {
            this.onTimeout();
        }, 1000);
    }

    componentDidMount() {
        if (this.props.redirect)
            this.onTimeout()
    }

    render() {
        const { classes } = this.props;

        return (
            <main className={classes.main}>
                <CssBaseline />

                <Paper elevation={0} className={classes.paper}>
                    <br/>
                    <br/>
                    <Typography align={"center"} variant='h6' color={"primary"}>The path "{window.location.pathname}"
                        does not
                        exist. {this.props.redirect && "You will be redirected to Login in {this.state.timeout} seconds."}</Typography>

                </Paper>
            </main>
        );
    }
}



export default withStyles(styles)(PathError);
